import React, { useRef, useState } from "react";
import { AttachmentRequestDto, AttachmentsClient } from '../web-api-client.ts';
import axios from "axios";
import { Form, Button, Card, Spinner } from "react-bootstrap";
import Loader from "./Loader.js";


const Upload = ({ type, entityId, name, description, buttonLabel, onComplete }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null); // Create a reference for the file input

  const handleFileChange = async (event) => {
    setUploading(true);
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    //setPreview(URL.createObjectURL(selectedFile));
   

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("type", type); // Add type
    formData.append("id", entityId);   // Add id
    formData.append("name", name);   // Add id
    formData.append("description", description);   // Add id


    const baseUrl = window.location.origin; // Get the base URL of the current URL
    try {
      const response = await axios.post(
        `${baseUrl}/api/Attachments/${entityId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" },
        withCredentials: false,   }
      );
      console.log("Uploaded URL:", response.data.Url);
    } catch (error) {
      console.error("Upload failed:", error);
    }
      //alert("Upload successful!");
      setUploading(false);
      onComplete();
  };

  const handleUploadClick = () => {
    fileInputRef.current.click(); // Trigger the file input click event
  };
  return (
   <div className="container text-center mb-3">
    <Form.Group controlId="fileUpload">
      {uploading ?? <Loader />}
       
        <Form.Control
          type="file"
          onChange={handleFileChange}
          accept="*/*"
          ref={fileInputRef} // Add the reference to the file input
          style={{ display: "none" }} // Hide the default file input
        />
        <Button onClick={handleUploadClick}>{buttonLabel}</Button> {/* Add the "Upload" button */}
      </Form.Group>

      {/* {preview && (
        <div className="text-center mt-3">
          <img
            src={preview}
            alt="Preview"
            className="img-thumbnail"
            style={{ maxWidth: "200px" }}
          />
        </div>
      )} */}
   </div>
  );
};

export default Upload;
